import { action } from 'typesafe-actions';
import { LodgeEnquiryActionTypes, SetShapePayload } from 'types';

export const fetchLodgeEnquiryInit = () =>
  action(LodgeEnquiryActionTypes.FETCH_LODGE_ENQUIRY_INIT);

export const fetchLodgeEnquiryRequest = (req: any) =>
  action(LodgeEnquiryActionTypes.FETCH_LODGE_ENQUIRY_REQUEST, req);

export const fetchLodgeEnquirySuccess = (data: string) =>
  action(LodgeEnquiryActionTypes.FETCH_LODGE_ENQUIRY_SUCCESS, data);

export const fetchLodgeEnquiryFailure = (errors: string) =>
  action(LodgeEnquiryActionTypes.FETCH_LODGE_ENQUIRY_FAILURE, errors);

export const clearLodgeEnquiryDetails = () =>
  action(LodgeEnquiryActionTypes.CLEAR_LODGE_ENQUIRY_DETAILS);

export const setEnquiryAddress = (data: any) =>
  action(LodgeEnquiryActionTypes.SET_ENQUIRY_ADDRESS, data);

export const setShape = (payload: SetShapePayload) =>
  action(LodgeEnquiryActionTypes.SET_SHAPE, payload);

export const clearShape = () => action(LodgeEnquiryActionTypes.CLEAR_SHAPE);

export const fetchEnquiryJobRequest = (req: any) =>
  action(LodgeEnquiryActionTypes.FETCH_ENQUIRY_JOB_REQUEST, req);

export const fetchEnquiryJobSuccess = (res: any) =>
  action(LodgeEnquiryActionTypes.FETCH_ENQUIRY_JOB_SUCCESS, res);

export const fetchLastEnquiryRequest = () =>
  action(LodgeEnquiryActionTypes.FETCH_LAST_ENQUIRY_REQUEST);

export const fetchLastEnquirySuccess = (req: any) =>
  action(LodgeEnquiryActionTypes.FETCH_LAST_ENQUIRY_SUCCESS, req);

export const clearLastEnquiry = () =>
  action(LodgeEnquiryActionTypes.CLEAR_LAST_ENQUIRY);

/* Clone existing enquiry */
export const cloneExistingEnquiryById = (req: any) =>
  action(LodgeEnquiryActionTypes.CLONE_EXISTING_ENQUIRY_REQUEST, req);

export const cloneExistingEnquiryFailure = (err: any) =>
  action(LodgeEnquiryActionTypes.CLONE_EXISTING_ENQUIRY_FAILURE, err);

export const clearCloneEnquiry = () =>
  action(LodgeEnquiryActionTypes.CLEAR_CLONE_ENQUIRY);

export const setSandBoxTestingMode = (value: any) =>
  action(LodgeEnquiryActionTypes.SANDBOX_TESTING_MODE, value);

export const saveEnquiryPresetsStart = (req: any) =>
  action(LodgeEnquiryActionTypes.SAVE_ENQUIRY_PRESETS_START, req);

export const saveEnquiryPresetsSuccess = () =>
  action(LodgeEnquiryActionTypes.SAVE_ENQUIRY_PRESETS_SUCCESS);

export const saveEnquiryPresetsFailure = (req: any) =>
  action(LodgeEnquiryActionTypes.SAVE_ENQUIRY_PRESETS_FAILURE, req);

export const deleteEnquiryPresetsStart = () =>
  action(LodgeEnquiryActionTypes.DELETE_ENQUIRY_PRESETS_START);

export const deleteEnquiryPresetsSuccess = () =>
  action(LodgeEnquiryActionTypes.DELETE_ENQUIRY_PRESETS_SUCCESS);

export const deleteEnquiryPresetsFailure = (req: any) =>
  action(LodgeEnquiryActionTypes.DELETE_ENQUIRY_PRESETS_FAILURE, req);

export const goToEnquiryPresets = (data: any) =>
  action(LodgeEnquiryActionTypes.GO_TO_ENQUIRY_PRESETS, data);

export const returnFromEnquiryPresets = () =>
  action(LodgeEnquiryActionTypes.RETURN_FROM_ENQUIRY_PRESETS);

export const completedReturnFromEnquiryPresets = () =>
  action(LodgeEnquiryActionTypes.COMPLETED_RETURN_FROM_ENQUIRY_PRESETS);

export const clearEnquiryPresets = () =>
  action(LodgeEnquiryActionTypes.CLEAR_ENQUIRY_PRESETS);

export const setLiveArea = (payload: number | undefined) =>
  action(LodgeEnquiryActionTypes.SET_LIVE_AREA, payload);

export const prePopulateEnquiryData = (data: any) =>
  action(LodgeEnquiryActionTypes.PRE_POPULATE_ENQUIRY_DATA, data);

export const updateLodgeEnquiryReferral = (data: any) =>
  action(LodgeEnquiryActionTypes.UPDATE_LODGE_ENQUIRY_REFERRAL, data);
